/* eslint-disable no-use-before-define */

import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import Radium, { Style } from 'radium';
import reportRequest from 'helper/ReportingDashboard';
import Events from 'helper/ReportingDashboard/utils/eventsList';
import { SnackBarHelper } from '@lyearn-team/frontend-components';

import { interactionsBlocked } from '../../../../helper/blockUserInteractionHelper';
import SubmissionItem from './SubmissionItem';
import Icon from '../../../../helper/Icon';
import PeerReviewView from './PeerReviewView';

@Radium
class SubmissionHelper extends Component {
  static childContextTypes = {
    checkForSubmit: PropTypes.func,
    showTroublePopup: PropTypes.func,
    checkIfSubmittingResponses: PropTypes.func
  };

  state = {
    completionStatusBasedShowSubmitButton: false
  };

  makeSaveButtonVisible = false;
  allSaved = true;
  submissibleFlag = true;

  submissionItemRefs = [];
  questionAnswers = [];

  getChildContext() {
    return {
      checkIfSubmittingResponses: this.checkIfSubmittingResponses,
      showTroublePopup: this.showTroublePopup,
      checkForSubmit: this.checkForSubmit
    };
  }

  componentDidMount() {
    this.submissibleFlag = true;
    if (
      this.submissibleFlag !== this.checkIfSubmissible().submit ||
      this.allSaved !== this.checkIfSubmissible().save
    ) {
      this.submissibleFlag = this.checkIfSubmissible().submit;
      this.allSaved = this.checkIfSubmissible().save;
      this.setState({});
    }
    this.updateSubmitButtonViewStatus(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.cardId !== this.props.cardId) {
      this.submissionItemRefs = [];
      this.questionAnswers = [];
      this.makeSaveButtonVisible = false;
    }
    this.updateSubmitButtonViewStatus(nextProps);
  }

  componentDidUpdate() {
    if (
      this.submissibleFlag !== this.checkIfSubmissible().submit ||
      this.allSaved !== this.checkIfSubmissible().save
    ) {
      this.submissibleFlag = this.checkIfSubmissible().submit;
      this.allSaved = this.checkIfSubmissible().save;
      this.setState({});
    }
  }

  updateSubmitButtonViewStatus = props => {
    if (!props.card.performance || props.card.performance.completionStatus !== 'COMPLETE') {
      this.setState({
        completionStatusBasedShowSubmitButton: true
      });
    } else {
      this.setState({
        completionStatusBasedShowSubmitButton: false
      });
    }
  };

  checkIfSubmittingResponses = () => !!this.submittingResponses;

  showTroublePopup = open => {
    this.setState(
      { showTroublePopup: open },
      () => this.props.toggleFullscreen && this.props.toggleFullscreen(open)
    );
  };

  createMarkup = () => ({ __html: this.props.card.description });

  setSubmissionItemRef = index => ref => {
    ref && (this.submissionItemRefs[index] = ref);
  };

  clearAllSubmissions = () => {
    this.makeSaveButtonVisible = false;
    this.submissionItemRefs.forEach(
      r =>
        r &&
        r.activeSubmissionRef &&
        r.activeSubmissionRef.emptySubmittedResponse &&
        r.activeSubmissionRef.emptySubmittedResponse()
    );
  };

  calculatePR = (question, { response, answerEvaluation, responseType }, actualSubmit) => {
    // const answerObj = question.answer[0];
    // const answerObj = response;
    if (!actualSubmit) {
      return { progressMeasure: 0, rawScore: 0 };
    }
    if (responseType === 'SINGLE_SELECT' || responseType === 'MULTIPLE_SELECT') {
      // console.log('question::', question);
      return {
        progressMeasure: response !== '' ? 1 : 0,
        rawScore: (answerEvaluation === 'TRUE' ? question.maxScore : question.minScore) || 0
      };
    }
    if (responseType === 'EMPTY') {
      return { progressMeasure: 0, rawScore: question.rawScore };
    }
    return { progressMeasure: 1, rawScore: question.rawScore };
  };

  makeOneAnswer = (
    question,
    { questionId, response, answerEvaluation, responseType },
    actualSubmit
  ) => {
    // let questionFound = false;
    // console.log('questionId:: ', questionId);
    const { progressMeasure, rawScore } = this.calculatePR(
      question,
      { questionId, response, answerEvaluation, responseType },
      actualSubmit
    );
    return {
      questionId,
      response,
      answerEvaluation,
      responseType,
      rawScore,
      progressMeasure,
      timeStamp: new Date().toISOString()
    };
  };

  checkForSubmit = () => {
    this.makeSaveButtonVisible = true;
    this.setState({});
  };

  checkForSaveButtonStatus = (currentResponses, submissions) => {
    let allSaved = true;
    currentResponses.forEach(cr => {
      const matchedSubmission = submissions.filter(
        submission =>
          !!submission.questionId && submission.questionId === (cr && cr.questionObj.pid)
      )[0];
      if (
        allSaved &&
        matchedSubmission &&
        matchedSubmission.response !== cr.responseData.response
      ) {
        allSaved = false;
      }
    });
    // console.log(allSaved);
    // this.allSaved = allSaved;
    return allSaved;
  };

  checkIfSubmissible = submissionResponses => {
    let responses;
    if (submissionResponses) responses = submissionResponses;
    else {
      responses = this.submissionItemRefs.map(
        r => r && r.activeSubmissionRef && r.activeSubmissionRef.getResponse()
      );
    }
    // console.log('responses::', responses.map(r => r && r.responseData.response));

    const allSaved = this.checkForSaveButtonStatus(responses, this.props.submissions);
    // this.allSaved = allSaved;

    let validSubmit = true;
    responses &&
      responses.forEach(sr => {
        // console.log(sr.responseData.isOptional, ' ',  sr.responseData.response);
        if (
          !sr ||
          (!sr.responseData ||
            (!sr.responseData.isOptional && sr.responseData.response === '') ||
            (!sr.responseData.response && !sr.responseData.isOptional))
        )
          validSubmit = false;
      });
    // this.submissibleFlag = validSubmit;
    return { submit: validSubmit, save: allSaved };
  };

  submitAllResponses = () => {
    const { courseId } = this.props;
    const { name } = this.props.rootQForQuiz;
    const { globalPosition, name: lessonName, pid: cardId, resource } = this.props.card;
    const data = {
      courseId,
      courseName: name,
      cardId,
      lessonIndex: globalPosition,
      lessonName,
      lessonType: resource.type
    };
    if (this.props.preview || this.props.guestMode) return false;
    if (this.props.actualSubmit && !this.state.completionStatusBasedShowSubmitButton) return false;
    const actualSubmit = true;
    this.submittingResponses = true;
    this.questionAnswers = [];
    let submissionResponses = this.submissionItemRefs.map(
      r => r && r.activeSubmissionRef && r.activeSubmissionRef.getResponse()
    );
    if (!this.checkIfSubmissible(submissionResponses).submit) {
      SnackBarHelper.showSnackbar({
        label: 'You have to answer all questions to submit this assignment.'
      });
      return false;
    }
    submissionResponses = submissionResponses.filter(
      sr => sr && sr.responseData && sr.responseData.response && sr.responseData.response !== ''
    );
    submissionResponses.forEach((r, index) => {
      if (r && r.responseData) {
        this.questionAnswers[index] = this.makeOneAnswer(
          r.questionObj,
          r.responseData,
          actualSubmit
        );
      } else {
        this.questionAnswers[index] = undefined;
      }
    });
    this.props.postSubmission(
      {
        isRemoved: false,
        answerArray: this.questionAnswers,
        submisisonCallBacks: submissionResponses.map(s => s.callBack),
        actualSubmit
      },
      () => {
        this.submissionItemRefs.forEach(
          r =>
            r &&
            r.activeSubmissionRef &&
            r.activeSubmissionRef.emptySubmittedResponse &&
            r.activeSubmissionRef.emptySubmittedResponse()
        );
        reportRequest(Events.RESPONSE_SUBMITTED, data);
      },
      () => {
        this.submittingResponses = false;
      }
    );
    return true;
  };

  saveResponses = deletingResponse => {
    if (interactionsBlocked()) {
      return false;
    }
    if (this.props.actualSubmit) return false;
    const actualSubmit = false;

    // console.log('submissionItemRefs', this.submissionItemRefs.map(r => r.activeSubmissionRef && r.activeSubmissionRef.getResponse()));
    this.questionAnswers = [];
    let submissionResponses = this.submissionItemRefs.map(
      r => r && r.activeSubmissionRef && r.activeSubmissionRef.getResponse()
    );
    submissionResponses = submissionResponses.filter(
      sr =>
        sr &&
        sr.responseData &&
        ((sr.responseData.response && sr.responseData.response !== '') ||
          sr.responseData.deletingResponse)
    );
    submissionResponses.forEach((r, index) => {
      if (r && r.responseData) {
        this.questionAnswers[index] = this.makeOneAnswer(
          r.questionObj,
          r.responseData,
          actualSubmit
        );
      } else {
        this.questionAnswers[index] = undefined;
      }
    });
    this.props.postSubmission(
      {
        isRemoved: false,
        answerArray: this.questionAnswers,
        submisisonCallBacks: submissionResponses.map(s => s.callBack),
        actualSubmit
      },
      () => {
        if (deletingResponse === true) {
          SnackBarHelper.showSnackbar({
            label: 'Your response has been removed'
          });
        }
        this.submissionItemRefs.forEach(
          r =>
            r &&
            r.activeSubmissionRef &&
            r.activeSubmissionRef.emptySubmittedResponse &&
            r.activeSubmissionRef.emptySubmittedResponse()
        );
      }
    );
    return true;
  };

  saveOneResponse = (getResponseData, cardId) => {
    const actualSubmit = false;
    if (interactionsBlocked() || this.checkIfSubmittingResponses()) {
      return false;
    }
    if (this.props.preview || this.props.guestMode) {
      this.setState({});
      return false;
    }
    const submissionResponses = [getResponseData];
    submissionResponses.forEach((r, index) => {
      if (r && r.responseData) {
        this.questionAnswers[index] = this.makeOneAnswer(
          r.questionObj,
          r.responseData,
          actualSubmit
        );
      } else {
        this.questionAnswers[index] = undefined;
      }
    });

    this.props.postSubmission(
      {
        isRemoved: false,
        answerArray: this.questionAnswers,
        submisisonCallBacks: submissionResponses.map(s => s.callBack),
        actualSubmit,
        cardId
      },
      () => {
        this.props.submissions[0].answerType !== 'TEXT' &&
          getResponseData.emptySubmittedResponse &&
          getResponseData.emptySubmittedResponse();
        if (
          this.props.submissions.length === 1 &&
          (this.props.submissions[0].answerType === 'VIDEO' ||
            this.props.submissions[0].answerType === 'AUDIO')
        ) {
          // Disabling auto-submit video / audio assignments
          /* setTimeout(() => {
            this.submitAllResponses();
          }, 10); */
        }
      }
    );
    return true;
  };

  peerReviewsAvailable = () => {
    const peerReview =
      this.props.card.questionAnswers[0] &&
      this.props.card.questionAnswers[0] &&
      this.props.card.questionAnswers[0].answer &&
      this.props.card.questionAnswers[0].answer[0] &&
      this.props.card.questionAnswers[0].peerQuestions &&
      this.props.card.questionAnswers[0].peerQuestions.length > 0 &&
      this.props.card.questionAnswers[0].gradingScheme === 'PEER_GRADABLE' &&
      this.props.card.performance &&
      this.props.card.performance.completionStatus === 'COMPLETE';
    const noReviews = () => {
      let noReviewsAvailable = true;
      this.props.card.questionAnswers[0] &&
        this.props.card.questionAnswers[0].peerQuestions.forEach &&
        this.props.card.questionAnswers[0].peerQuestions.forEach(pq => {
          if (pq.reviewsReceived.length > 0) noReviewsAvailable = false;
        });
      // console.log(noReviews);
      return noReviewsAvailable;
    };
    return peerReview && !noReviews();
  };

  parseAnswerTypeFromResponse(submission) {
    if (
      submission.answer &&
      submission.answer.answerType &&
      submission.answer.answerType !== 'EMPTY'
    ) {
      return submission.answer.answerType;
    }
    return submission.answerType;
  }

  renderIntroMesssage = () => {
    if (!this.props.card.description) {
      return null;
    }
    return (
      <div style={styles.redactorContainerDescription} className="redactor-container preview">
        <div style={styles.introMessageContainer} className="introMessageContainer redactor-styles">
          <div dangerouslySetInnerHTML={this.createMarkup()} />
        </div>
      </div>
    );
  };

  @autobind
  renderSubmissionItems() {
    return this.props.submissions.map((submission, i) => (
      <SubmissionItem
        key={i}
        ref={this.setSubmissionItemRef(i)}
        userId={this.props.userId}
        submission={submission}
        options={submission.options}
        position={i + 1}
        questionId={submission.questionId}
        questionObj={submission.questionObj}
        cardId={this.props.cardId}
        cardName={this.props.cardName}
        card={this.props.card}
        successSubmitAudio={this.props.successSubmitAudio}
        changeResponseTypePressed={this.props.changeResponseTypePressed}
        showEnrollDialog={this.props.showEnrollDialog}
        isEnrolled={this.props.isEnrolled}
        getSubmissions={this.props.getSubmissions}
        parseAnswerTypeFromResponse={this.parseAnswerTypeFromResponse}
        toggleFullscreen={this.props.toggleFullscreen}
        fullScreen={this.props.fullScreen}
        actualSubmit={this.props.actualSubmit}
        saveResponses={this.saveResponses}
        saveOneResponse={this.saveOneResponse}
        totalSubmissions={this.props.submissions.length}
        isLastItem={i + 1 === this.props.submissions.length}
        isComplete={
          this.props.card.performance && this.props.card.performance.completionStatus !== 'COMPLETE'
        }
      />
    ));
  }

  /*   @autobind
  renderPeerReviewBox() {
    const nextCard = this.props.cardArray[this.props.cardArrayCurrentCardIndex + 1];
    return <PeerReviewBox card={this.props.card} nextCard={nextCard || null} />;
  } */

  renderTroublePopup = () => (
    <div style={styles.troublePopupContainer} className="troublePopupContainer">
      <div className="troubleContentContainer">
        <div className="troublePopupClose" onClick={() => this.showTroublePopup(false, null)}>
          <Icon icon="close" fill="#90a0b7" size="20px" />
        </div>
        <p style={styles.troubleHeading} className="troubleTitle">
          Troubleshoot Recording Issues
        </p>
        <div>
          <p>If you are facing issues recording your assignment,</p>
          <ul style={styles.mainList}>
            <li style={styles.mainLi}>
              <a
                href="https://intercom.help/lyearn/learner/manage-your-permissions"
                target="_blank"
                rel="noopener noreferrer"
              >
                Manage your permissions
              </a>
            </li>
            <li style={styles.mainLi}>
              Use an external software to record your assignment and upload it on Lyearn. The
              accepted submission formats are as follows:
              <ul style={styles.subList}>
                <li style={styles.subLi}>For video submissions: mp4, m4v, mov, avi</li>
                <li style={styles.subLi}>For audio submissions: mp3, wav, m4a</li>
              </ul>
            </li>
          </ul>
          <p>To learn how to record on an external software, please follow the links below:</p>
          <ul style={styles.mainList}>
            <li style={styles.mainLi}>
              For MacOS users:
              <ul style={styles.subList}>
                <li style={styles.subLi}>
                  <a
                    href="https://intercom.help/lyearn/learner/how-to-record-video-assignment-for-macos"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Record a Video on Mac
                  </a>
                </li>
                <li style={styles.subLi}>
                  <a
                    href="https://intercom.help/lyearn/learner/how-to-record-audio-assignments-on-macos"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Record an Audio on Mac
                  </a>
                </li>
              </ul>
            </li>
            <li style={styles.mainLi}>
              For Windows OS users:
              <ul style={styles.subList}>
                <li style={styles.subLi}>
                  <a
                    href="https://intercom.help/lyearn/learner/how-to-record-video-assignments-on-windows-os"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Record a Video on Windows
                  </a>
                </li>
                <li style={styles.subLi}>
                  <a
                    href="https://intercom.help/lyearn/learner/how-to-record-audio-assignments-for-windows-os"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Record an Audio on Windows
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <p>
            If the issue still persists, you can share your submissions with us on{' '}
            <a href="mailto:support@lyearn.com">support@lyearn.com</a> in the format specified below
            and we will upload it on your behalf:
          </p>
          <ul>
            <li>Name of the course:</li>
            <li>Lesson Number:</li>
            <li>Question Number: (if applicable)</li>
          </ul>
          <p>Sorry for the inconvenience caused.</p>
        </div>
      </div>
    </div>
  );

  renderNoQuestionView = styles => <div style={styles.noQuestion}>Empty assignment</div>;

  render() {
    const card = this.props.card;
    const passScore = card.minScaledScore * (card.maxScore - card.minScore) + card.minScore;

    if (!this.props.submissions || this.props.submissions.length === 0)
      return this.renderNoQuestionView(styles);
    return (
      <div className="submissionHelperContainer" style={[styles.innerContainer]}>
        {card.contributeToSuccessStatus &&
        card.performance &&
        card.performance.completionStatus !== 'COMPLETE' ? (
          <div style={[styles.instructionContainer, styles.displayFlexColumn]}>
            <div style={[styles.instructionTitle, styles.displayFlexRow, styles.alignItemsCenter]}>
              How To Pass
              <Icon icon="info" fill="#c8cfd6" size="22px" style={styles.actionInfo} />
            </div>
            <div style={styles.instructionText}>
              You need to score at least {Math.ceil(passScore)}/{card.maxScore} to pass this
              assignment.
            </div>
          </div>
        ) : null}
        {this.renderIntroMesssage()}
        {this.renderSubmissionItems()}
        <div style={styles.buttonsContainer} />

        {this.props.card.contributeToSuccessStatus &&
        this.props.card.performance &&
        this.props.card.performance.completionStatus === 'COMPLETE' ? null : (
          <div style={styles.buttonsContainer}>
            {this.submissibleFlag &&
            (!this.props.actualSubmit || this.state.completionStatusBasedShowSubmitButton) ? (
              <div style={[styles.submitButton]} onClick={this.submitAllResponses}>
                SUBMIT
              </div>
            ) : null}
          </div>
        )}
        {this.peerReviewsAvailable() ? (
          <div>
            <PeerReviewView rootQ={this.props.rootQForQuiz} userId={this.props.userId} />
          </div>
        ) : null}
        {this.state.showTroublePopup ? this.renderTroublePopup() : null}
        <Style rules={styles.classBased} scopeSelector=".submissionHelperContainer" />
      </div>
    );
  }
}

const styles = {
  classBased: {
    '.introMessageContainer': {
      marginTop: '67px'
    },
    '.troublePopupContainer': {
      background: '#fff',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      padding: '8% 0 0 22%',
      zIndex: '1'
    },
    '.troubleContentContainer': {
      maxWidth: '547px'
    },
    '.troublePopupContainer p.troubleTitle': {
      fontFamily: 'ProximaNova-Semibold',
      color: '#3b4859',
      fontSize: '22px',
      margin: '0 0 30px'
    },
    '.troublePopupClose': {
      background: '#e5e9f2',
      borderRadius: '50%',
      padding: '9px 9px',
      cursor: 'pointer'
    },
    '.troublePopupContainer p, .troublePopupContainer ul': {
      fontFamily: 'ProximaNova-Regular',
      color: '#8392a7',
      fontSize: '14px',
      lineHeight: '18px',
      margin: '0 0 10px'
    },
    '.troublePopupContainer .marginBottom50': {
      margin: '0 0 50px 0'
    },
    '.troublePopupContainer .highlight': {
      fontSize: '17px',
      lineHeight: '22px',
      color: '#3b4859'
    },
    '.troublePopupContainer a': {
      textDecoration: 'none'
    },
    '.troublePopupContainer .highlight a': {
      color: '#3b4859'
    },
    '.troublePopupContainer .troublePopupClose': {
      position: 'absolute',
      top: '36px',
      right: '36px'
    }
  },
  noQuestion: {
    width: '85%',
    maxWidth: '809px',
    margin: '0px auto',
    backgroundColor: 'transparent',
    zIndex: '2',
    paddingTop: '0px',
    height: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px'
  },
  innerContainer: {
    color: 'rgba(0,0,0,0.8)',
    padding: '0px 0px 20px',
    boxSizing: 'border-box',
    width: '100%',
    margin: '0 auto',
    position: 'relative'
  },
  innerFullContainer: {
    width: '100%'
  },
  opeHeaderContainer: {
    width: '100%',
    marginBottom: '16px'
  },
  opeInstructionContainer: {
    background: 'rgba(219, 226, 232, 0.4)',
    border: 'solid 1px #dbe2e8',
    display: 'flex',
    alignItems: 'center',
    color: '#294860',
    fontWeight: '500',
    borderRadius: '1px',
    flexDirection: 'row',
    padding: '0 28px'
  },
  minHeight55: {
    minHeight: '55px'
  },
  minHeight75: {
    minHeight: '75px'
  },
  headerText: {
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    width: '100%',
    display: 'flex'
  },
  marginBottomSix: {
    marginBottom: '6px'
  },
  marginBottomZero: {
    marginBottom: '0px'
  },
  completionText: {
    fontSize: '14px',
    lineHeight: '19px',
    width: '100%',
    display: 'flex'
  },
  opeInstructionInnerWrapper: {
    width: '100%'
  },
  opeOverdueInfoContainer: {
    border: 'solid 1px #d0021b',
    minHeight: '42px',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '0 20px 0 28px',
    marginBottom: '14px'
  },
  displayNone: {
    display: 'none'
  },
  displayFlex: {
    display: 'flex'
  },
  opeOverdueInfoInnerWrapper: {
    width: '100%'
  },
  overdueText: {
    fontSize: '15px',
    fontWeight: '500',
    letterSpacing: '0.5px',
    color: '#d0021b',
    lineHeight: '20px',
    float: 'left',
    textTransform: 'uppercase'
  },
  weekendText: {
    float: 'right',
    fontSize: '14px',
    lineHeight: '19px',
    letterSpacing: '0.1px',
    color: '#7b96ac'
  },
  viewPastResponseText: {
    color: '#4a90e2',
    fontSize: '13px',
    lineHeight: '18px',
    letterSpacing: '0.9px',
    fontWeight: '500',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    textTransform: 'uppercase',
    marginTop: '30px',
    cursor: 'pointer'
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  submitButton: {
    padding: '12px 96px',
    background: '#0abff1',
    color: '#fff',
    cursor: 'pointer',
    fontWeight: 600,
    textTransform: 'uppercase',
    fontSize: '13px',
    border: '0px',
    margin: '20px 0 0',
    minWidth: '248px',
    textAlign: 'center',
    boxSizing: 'border-box',
    borderRadius: '2px'
  },
  saveButton: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '248px',
    padding: '8px 88px',
    textAlign: 'center',
    cursor: 'pointer',
    borderRadius: '2px',
    color: '#00aad9',
    textTransform: 'uppercase',
    fontSize: '13px',
    // lineHeight: '18px',
    fontWeight: 600,
    border: '1px solid #00b6e8',
    boxSizing: 'border-box',
    justifyContent: 'center'
  },
  savedStateButton: {
    cursor: 'pointer',
    color: '#9EA7B1',
    border: '1px solid #9EA7B1'
  },
  buttonDisabled: {
    opacity: '0.4',
    display: 'none'
  },
  instructionContainer: {
    border: '1px solid #dbe2e8',
    borderRadius: '4px',
    padding: '16px 20px',
    marginBottom: '18px'
  },
  instructionTitle: {
    fontSize: '15px',
    lineHeight: '18px',
    color: '#294860',
    fontWeight: 'bold',
    marginBottom: '12px'
  },
  displayFlexColumn: {
    display: 'flex',
    flexDirection: 'column'
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  instructionText: {
    fontSize: '15px',
    lineHeight: '17px',
    color: '#294860'
  },
  actionInfo: {
    marginLeft: '5px'
  },
  iconStyle: {
    margin: '0 0 0 7px'
  },
  redactorContainerDescription: {
    paddingTop: '0px'
  },
  mainList: {
    listStyleType: 'decimal',
    listStylePosition: 'outside',
    paddingLeft: '15px'
  },
  mainLi: {
    marginBottom: 5
  },
  subList: {
    listStyle: 'none',
    marginTop: '10px',
    paddingLeft: '20px'
  },
  subLi: {
    marginBottom: 3
  }
};

export default SubmissionHelper;
